import { IonRow, IonText } from '@ionic/react';

// Style
import styles from '@/components/Loading/Loading.module.css';
import { Spinner } from '@/components/Spinner/Spinner';

interface LoadingProps {
  message?: string;
}

export const Loading = ({ message }: LoadingProps) => {
  return (
    <>
      <IonRow className='ion-justify-content-center'>
        <div>
          <Spinner />
          <IonText className={styles['sub-title']}>{message ? message : 'Loading data please wait...'}</IonText>
        </div>
      </IonRow>
    </>
  );
};
